import { Component, OnInit } from "@angular/core";
import { WebApiService } from "src/app/shared/web-api/web-api.service";

@Component({
  standalone: false,
  selector: "app-quick-links",
  templateUrl: "./quick-links.component.html",
  styleUrls: ["./quick-links.component.scss"],
})
export class QuickLinksComponent implements OnInit {
  configuration: any = [];
  news: any;
  adminportal: any;
  leagalnotices: any;
  termsOfUse: any;
  support: any;
  assist: any;
  termsOfservice: any;
  privacy: any;
  status: any;
  cookies: any;
  attributions: any;
  webportal: any;
  releasenotes: any;
  constructor(
    private webApiService: WebApiService
  ) {
    this.webApiService.get<any>(`/apps/websites`).subscribe(
      quicklink => {
        this.configuration = quicklink;
        this.setAllquicklink(this.configuration);
      });
  }

  setAllquicklink(configuration) {
    for (let i = 0; i < configuration.length; i++) {
      if (configuration[i].Type == "adminportal")
        this.adminportal = configuration[i].Path;
      else if (configuration[i].Type == "legalnotices")
        this.leagalnotices = configuration[i].Path;
      else if (configuration[i].Type == "termsofuse")
        this.termsOfUse = configuration[i].Path;
      else if (configuration[i].Type == "attributions")
        this.attributions = configuration[i].Path;
      else if (configuration[i].Type == "assist")
        this.assist = configuration[i].Path;
      else if (configuration[i].Type == "termsofservice")
        this.termsOfservice = configuration[i].Path;
      else if (configuration[i].Type == "privacy")
        this.privacy = configuration[i].Path;
      else if (configuration[i].Type == "webportal")
        this.webportal = configuration[i].Path;
      else if (configuration[i].Type == "releasenotes")
        this.releasenotes = configuration[i].Path;
      else if (configuration[i].Type == "cookies")
        this.cookies = configuration[i].Path;
      else if (configuration[i].Type == "news")
        this.news = configuration[i].Path;
    }
  }
  ngOnInit() { }
}
